// export default AppCard;
import * as React from 'react';
import {
 Card, CardHeader, CardTitle, CardContent
} from 'shared/components/ui/card';
import {
 Button
} from 'shared/components/ui/button';
import {
 useContext, useState, useEffect
} from 'react';
import {
 useNavigate
} from 'react-router-dom';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from 'shared/components/ui/dropdown-menu';
import {
 getTimeDifference
} from 'shared/utils/timeUtils';
import {
 getOrganizationMember
} from 'shared/utils/organizationUtils';
import {
 OrganizationContext
} from 'shared/context/OrganizationContext';
import {
 MoreVertical, Trash2, Database, Settings, Users
} from 'lucide-react';
import useLazyLoad from 'shared/hooks/useLazyLoading';
import {
 Application
} from './types/builderApp.types';

interface AppCardProps {
  application: Application;
  onDelete: () => void;
}

const AppCard: React.FC<AppCardProps> = ({
 application, onDelete
}) => {
  const {
 app_id, full_name, active, created_at, modified_at, created_by, modified_by
} = application;
  const [createdByName, setCreatedByName] = useState<string>('');
  const [modifiedByName, setModifiedByName] = useState<string>('');
  const {
 selectedOrganization
} = useContext(OrganizationContext);
  const navigate = useNavigate();

  const getApplicationIcon = () => {
    return <Database size={28} color="white" />;
  };

  const handleGetOrganizationMember = async (memberId: string, setMemberName: React.Dispatch<React.SetStateAction<string>>) => {
    const member = await getOrganizationMember(memberId, selectedOrganization);
    setMemberName(member || '-');
  };

  const handleGetOrganizationNames = async () => {
    if ((created_by && created_by !== 'admin') && selectedOrganization) {
      handleGetOrganizationMember(created_by, setCreatedByName);
    } else {
      setCreatedByName('-');
    }
    if ((modified_by && modified_by !== 'admin') && selectedOrganization) {
      handleGetOrganizationMember(modified_by, setModifiedByName);
    } else {
      setModifiedByName(modified_by || '-');
    }
  };

  const {
 elementRef
} = useLazyLoad(handleGetOrganizationNames);

  useEffect(() => {
    handleGetOrganizationNames();
  }, [created_by, modified_by, selectedOrganization]);

  return (
      <Card ref={elementRef}>
          <CardHeader>
              <div className="flex w-full justify-between items-center">
                  <CardTitle onClick={() => navigate(`${app_id}/data-builder`)} className="cursor-pointer hover:underline ">
                      {full_name}
                  </CardTitle>

                  {/* Dropdown Menu for Actions */}
                  <div className="relative">
                      <DropdownMenu modal={false}>
                          <DropdownMenuTrigger asChild>
                              <Button variant="ghost" className="h-8 w-8 p-0">
                                  <MoreVertical className="h-4 w-4" />
                              </Button>
                          </DropdownMenuTrigger>
                          <DropdownMenuContent align="end">
                              <DropdownMenuLabel>Actions</DropdownMenuLabel>
                              <DropdownMenuSeparator />
                              <DropdownMenuItem onClick={() => navigate(`${app_id}/manage-app`)}>
                                  <Settings className="mr-2 h-4 w-4" />
                                  <span>Settings</span>
                              </DropdownMenuItem>
                              <DropdownMenuItem onClick={() => navigate(`${app_id}/data-builder/tables/User`)}>
                                  <Users className="mr-2 h-4 w-4" />
                                  <span>Manage Users</span>
                              </DropdownMenuItem>
                              <DropdownMenuSeparator />
                              <DropdownMenuItem onClick={onDelete} className="text-red-600">
                                  <Trash2 className="mr-2 h-4 w-4" />
                                  <span>Delete</span>
                              </DropdownMenuItem>
                          </DropdownMenuContent>
                      </DropdownMenu>
                  </div></div>
          </CardHeader>
          <CardContent>
              <div className="flex gap-3 items-center">
                  <span className="rounded-full size-16 flex justify-center items-center bg-[#b1092a]">
                      {getApplicationIcon()}
                  </span>
                  <ul className="flex flex-col">
                      <li className="text-sm text-muted-foreground">App Slug: <span>{application.name}</span></li>
                      <li className="text-sm text-muted-foreground">Created by: <span>{createdByName || '-'}</span></li>
                      <li className="text-sm text-muted-foreground">Active: <span>{active ? 'true' : 'false'}</span></li>
                      <li className="text-sm text-muted-foreground">Created at: <span>{getTimeDifference(created_at)}</span></li>
                      <li className="text-sm text-muted-foreground">
                          Updated {getTimeDifference(modified_at)} by {modifiedByName || '-'}
                      </li>
                  </ul>
              </div>
          </CardContent>
      </Card>
  );
};

export default AppCard;
